<template>
  <div class="container mt-0 mb-4">
    <div class="card shadow-sm p-4 bg-light">
      <!-- Encabezado -->
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Observaciones de Limpieza</h3>
      </div>

      <!-- Tabla de Observaciones -->
      <div v-if="observaciones.length">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>Habitación</th>
              <th>Observación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(obs, index) in observaciones" :key="index">
              <td>{{ obs.NumeroHabitacion }}</td>
              <td>{{ obs.ObservacionLimpieza }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="text-center text-muted">No hay observaciones registradas.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'ObservacionesLimpieza',
  data() {
    return {
      observaciones: []
    }
  },
  async mounted() {
    try {
      const res = await axios.get(`${API_URL}/reservacion-habitacion/observaciones`)
      this.observaciones = res.data
    } catch (error) {
      console.error('Error al cargar observaciones:', error)
    }
  },
  methods: {
    volver() {
      this.$router.push('/limpieza') // ajusta si usas otra ruta
    }
  }
}
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
